module.exports = "/assets/data/96aa2993dc9656ed730440338fd380d6-BT82.data.json";